import ServiceMainApi from "@/services/v2/service-main-api/ServiceMainApi";
import { plainToInstance } from "class-transformer";
import { validateOrReject } from "class-validator";
import ModelAddressType from "@models/v2/addressType/ModelAddressType";
import { tolgee } from "@/langs/tolgee";

export default class RepositoryAddressTypes {
    public async fetchAddressTypes(): Promise<ModelAddressType[]> {
        const { data } = await ServiceMainApi.of().get<{ data: { [key: string]: any }[] }>('/api/mobile/client/requisites/address_types');

        return await this.prepareAddressTypesData(data);
    }

    private async prepareAddressTypesData(data: { [key: string]: any }[]): Promise<ModelAddressType[]> {
        const addressTypes: ModelAddressType[] = [];

        for (const addressTypeData of data) {
            const model: ModelAddressType = await this.plainToModel(addressTypeData);

            addressTypes.push(model);
        }

        return addressTypes;
    }

    private async plainToModel(data: object): Promise<ModelAddressType> {
        const modelAddressType: ModelAddressType = plainToInstance(ModelAddressType, data, {
            excludeExtraneousValues: true,
            excludePrefixes: ['_']
        });

        await validateOrReject(modelAddressType);

        return modelAddressType;
    }
}
